export default __webpack_public_path__ + "static/media/ComputerCard.67146297.ico";